import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { gsap } from 'gsap';

/* ─── Variants ─────────────────────────────────────────────────── */
const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: {
        opacity: 1, x: 0,
        transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
    },
};

const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: {
        opacity: 1, x: 0,
        transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.15 },
    },
};

const textStagger = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.14, delayChildren: 0.2 } },
};

const textChild = {
    hidden: { opacity: 0, y: 18 },
    visible: {
        opacity: 1, y: 0,
        transition: { duration: 0.55, ease: 'easeOut' },
    },
};

/* ─── Main Component ───────────────────────────────────────────── */
function Child() {
    const { ref: sectionRef, inView } = useInView({ threshold: 0.2, triggerOnce: true });

    /* GSAP: background pulse on entry */
    const bgRef = useRef(null);
    useEffect(() => {
        if (inView && bgRef.current) {
            gsap.fromTo(
                bgRef.current,
                { backgroundSize: '102%' },
                { backgroundSize: '100%', duration: 0.8, ease: 'power2.out' }
            );
        }
    }, [inView]);

    /* GSAP: button magnetic hover */
    const btnRef = useRef(null);
    const handleEnter = () => gsap.to(btnRef.current, { scale: 1.07, duration: 0.3, ease: 'power2.out' });
    const handleLeave = () => gsap.to(btnRef.current, { scale: 1,    duration: 0.3, ease: 'power2.out' });

    return (
        <section
            ref={(el) => { sectionRef(el); bgRef.current = el; }}
            className="cta-area cta-bg pt-30 pb-30"
            style={{ background: '#fdc110' }}
        >
            <div className="container">
                <div className="row">

                    {/* ── Left: Text ── */}
                    <div className="col-lg-8">
                        <motion.div
                            className="section-title cta-title"
                            variants={fadeInLeft}
                            initial="hidden"
                            animate={inView ? 'visible' : 'hidden'}
                        >
                            <motion.div
                                variants={textStagger}
                                initial="hidden"
                                animate={inView ? 'visible' : 'hidden'}
                            >
                                <motion.h2 variants={textChild}>
                                    Ready to Start Your Career in Pharmacy?
                                </motion.h2>
                                <motion.p variants={textChild}>
                                    Admissions are now open for the B.Pharm program at
                                    Anjanadri Institute of Pharmacy. Affiliated to RGUHS and
                                    approved by the Government of Karnataka, we provide quality
                                    education with modern laboratories and experienced faculty.
                                </motion.p>
                            </motion.div>
                        </motion.div>
                    </div>

                    {/* ── Right: Button ── */}
                    <div className="col-lg-4 text-right">
                        <motion.div
                            className="cta-btn s-cta-btn"
                            variants={fadeInRight}
                            initial="hidden"
                            animate={inView ? 'visible' : 'hidden'}
                        >
                            <div
                                ref={btnRef}
                                style={{ display: 'inline-block' }}
                                onMouseEnter={handleEnter}
                                onMouseLeave={handleLeave}
                            >
                                <Link to="/contact-us" className="btn ss-btn smoth-scroll">
                                    Apply Now <i className="fal fa-long-arrow-right" />
                                </Link>
                            </div>
                        </motion.div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Child;
